export default {
  path: '/financeManage',
  name: '',
  component: () => import('@/components/layout/layout.vue'),
  redirect: '/financeManage/home',
  children: [
    {
      path: 'index',
      name: 'financeManageIndex',
      component: () => import('./index')
    },
    {
      path: 'payment_history',
      name: 'financeManageHistory',
      component: () => import('./paymentHistory/index')
    },
    {
      path: 'paymentSummary',
      name: 'financeManageSummary',
      component: () => import('./paymentSummary')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/pages/financeManage/router_financeManage.js